import API from "../../helpers/API";
import { toastr } from "react-redux-toastr";
import { SET_FORGOT_PASSWORD_STATE } from "../../common/constants/ActionTypes";
import {
  FORGETPASSWORD,
  RESETPASSWORD,
} from "../../common/constants/endpoints";
import label from "../labels/forgot_password_en.json";
import { handleError, handleResponseMessage } from "../../common/actions/commonActions";

export const submitForgotPassword = (data, otpDetails, userName) => {
  return async (dispatch) => {
    let reqBody;
    try {
      reqBody = {
        email: userName,
        emailOtpId: otpDetails.id,
        enteredEmailOtp: data.enteredEmailOtp,
        type: otpDetails.type,
      };
      let response = await API.post(FORGETPASSWORD, reqBody);
      let submitData = {
        flgSubmit: false,
        submitDetails: reqBody,
      };
      if (response && response.data) {
        submitData.flgSubmit = response.data;
        dispatch({
          payload: submitData,
          type: SET_FORGOT_PASSWORD_STATE,
        });
      }
    } catch (error) {
      // let errorMessage = "";
      // if (error.response && error.response.data) {
      //   errorMessage = error.response.data.message;
      // } else {
      //   errorMessage = error.message;
      // }
      // toastr.error(label.The_details_entered, errorMessage);
      handleError(error);
    }
  };
};

export const resetPassword = (data, props) => {
  return async (dispatch) => {
    try {
      let response = await API.post(RESETPASSWORD, data);
      let submitData = {
        flgSubmit: false,
        submitDetails: {},
      };
      dispatch({
        payload: submitData,
        type: SET_FORGOT_PASSWORD_STATE,
      });

      if (response.status === 200) {
        toastr.success(label.kindly_relogin_using_updated_password);
        props.history.push("/admin/login");
      }
    } catch (error) {
      // let errorMessage = "";
      // if (error.response && error.response.data) {
      //   errorMessage = error.response.data.message;
      // } else {
      //   errorMessage = error.message;
      // }
      // toastr.error(label.Password_not_updated, errorMessage);
      handleError(error);
    }
  };
};
